var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1211_5331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09091 12.0028H3.63636V5.82102L0 3.09375V10.9119C0 11.5156 0.489091 12.0028 1.09091 12.0028Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3635 12.0028H14.909C15.5126 12.0028 15.9999 11.5137 15.9999 10.9119V3.09375L12.3635 5.82102",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3635 1.0901V5.81737L15.9999 3.0901V1.63555C15.9999 0.286461 14.4599 -0.48263 13.3817 0.326461",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63647 5.82102V1.09375L8.00011 4.36648L12.3637 1.09375V5.82102L8.00011 9.09375",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.63555V3.0901L3.63636 5.81737V1.0901L2.61818 0.326461C1.53818 -0.48263 0 0.286461 0 1.63555Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1211_5331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.3951b9c6d38307d784fd4aedfb32d815.svg";
export { ForwardRef as ReactComponent };